import React from "react";
import { View, TouchableOpacity } from "react-native";
import Svg, { Path, G, Defs, ClipPath, Rect } from "react-native-svg";
import AppTheme from "../../AppTheme";

export default function SnoozeLater(props) {
  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_snoozelater)">
            <Path
                d="M9.81944 3.96363L11.3193 8.57776L13.5062 10.1955C13.7081 10.3226 13.883 10.4881 14.0209 10.6827C14.1588 10.8774 14.2571 11.0973 14.31 11.3299C14.3629 11.5624 14.3694 11.8032 14.3293 12.0383C14.2891 12.2734 14.203 12.4984 14.0759 12.7002L13.7535 13.2127C13.5821 13.484 13.3101 13.6764 12.9972 13.7476C12.6842 13.8189 12.3558 13.7632 12.0837 13.5929L2.20953 7.13621C1.93803 6.96476 1.74556 6.69268 1.6743 6.37958C1.60304 6.06649 1.6588 5.73791 1.82935 5.46585L4.14046 1.79234C4.38602 1.40176 5.05335 1.37923 5.18046 1.82238C5.31761 2.26546 5.54618 2.67484 5.85142 3.02407C6.15666 3.37329 6.53176 3.6546 6.9525 3.84981C7.8675 4.2122 8.87859 4.25234 9.81944 3.96363V3.96363Z"
                fill={AppTheme.almostBlack}
            />
            <Path
                d="M7.99998 12.6222H1.06665V13.7778H7.99998V12.6222Z"
                fill={AppTheme.almostBlack}
            />
            <Path
                d="M3.95554 9.73332H1.06665V10.8889H3.95554V9.73332Z"
                fill={AppTheme.almostBlack}
            />
        </G>
        <Defs>
            <ClipPath id="clip0_snoozelater">
                <Rect width="13.8667" height="13.8667" fill="white" transform="translate(1.06665 1.06667)"/>
            </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
